/**
 * @generated SignedSource<<39ea3d6e0f88481971cec9a363b97835>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Notifications$data = {
  readonly notifications: {
    readonly unseenNotificationCount: number;
  } | null | undefined;
  readonly " $fragmentType": "Nav4Notifications";
};
export type Nav4Notifications$key = {
  readonly " $data"?: Nav4Notifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Notifications">;
};

import Nav4NotificationsRefetchableQuery_graphql from './Nav4NotificationsRefetchableQuery.graphql';

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": Nav4NotificationsRefetchableQuery_graphql
    }
  },
  "name": "Nav4Notifications",
  "selections": [
    {
      "concreteType": "InfluentsNotificationQuery",
      "kind": "LinkedField",
      "name": "notifications",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "unseenNotificationCount"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "9fa4e72bf771cce7bab0cd69ec168049";

export default node;
